import React, { FC } from 'react'
import { FontSizeProps, theme } from '../../../theme'

export const OvenIcon: FC<{ size?: FontSizeProps }> = ({ size = 'x2' }) => {
  return (
    <svg
      width={theme.fontSizes[size]}
      height={theme.fontSizes[size]}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 0.89543 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V6V17C20 18.1046 19.1046 19 18 19C18 19.5523 17.5523 20 17 20H16C15.4477 20 15 19.5523 15 19H5C5 19.5523 4.55228 20 4 20H3C2.44772 20 2 19.5523 2 19C0.895431 19 0 18.1046 0 17V6V2ZM4 3C4 3.55228 3.55228 4 3 4C2.44772 4 2 3.55228 2 3C2 2.44772 2.44772 2 3 2C3.55228 2 4 2.44772 4 3ZM3 7H17V16H3V7ZM2 16V6H18V16C18 16.5523 17.5523 17 17 17H3C2.44772 17 2 16.5523 2 16ZM7 4C7.55228 4 8 3.55228 8 3C8 2.44772 7.55228 2 7 2C6.44772 2 6 2.44772 6 3C6 3.55228 6.44772 4 7 4ZM6.73223 10.2678C6.53697 10.463 6.53697 10.7796 6.73223 10.9749L9.20711 13.4497C9.59763 13.8403 10.2308 13.8403 10.6213 13.4497L7.43934 10.2678C7.24408 10.0725 6.9275 10.0725 6.73223 10.2678ZM9.20711 10.6213C9.59763 10.2308 10.2308 10.2308 10.6213 10.6213L13.0962 13.0962C13.2915 13.2915 13.2915 13.608 13.0962 13.8033C12.9009 13.9986 12.5843 13.9986 12.3891 13.8033L9.20711 10.6213Z"
        fill="black"
      />
    </svg>
  )
}
